import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';

const NotFoundPage = () => (
  <div className="not-found">
    <h1>Wrong turn</h1>
    <p>There’s no page at this address.</p>
    <Button component={Link} to="/dashboard" variant="contained">Go to My customers</Button>
  </div>
);

export default NotFoundPage;
